import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ReactNode } from 'react';
import './DoseTabs.scss';

interface DoseTabsProps {
  serviceType?: string;
  tabs: {
    id: number;
    title: ReactNode;
  }[];
  tabValue: number;
  handleTabChange: (value: number) => void;
}

const DoseTabs = ({ tabs, handleTabChange, tabValue, serviceType }: DoseTabsProps) => {
  const renderTabs = tabs.map((tab) => {
    return (
      <Tab
        key={tab.id}
        eventKey={tab.id}
        title={tab.title}
      ></Tab>
    );
  });

  return (
    <>
      <div className="d-md-none">
        <select
          className="form-select rounded-pill"
          value={tabValue}
          onChange={(e) => handleTabChange(Number(e.target.value))}
        >
          {tabs.map((tab) => (
            <option
              key={tab.id}
              value={tab.id}
            >
              {tab.title}
            </option>
          ))}
        </select>
      </div>

      <div className="d-none d-md-block">
        <Tabs
          defaultActiveKey={tabs[0].id}
          activeKey={tabValue}
          id="dosing"
          onSelect={(value) => handleTabChange(Number(value))}
          className="mb-3"
          fill
        >
          {renderTabs}
        </Tabs>
      </div>
    </>
  );
};

export default DoseTabs;
